module.exports = __webpack_public_path__ + "img/stake-logo.6713d75f.png";